import { Record } from 'immutable';
import { isString, pickBy } from 'lodash';
import COUNTRIES from '../constants/countries.js';

const ConfigsRecord = Record({
    organizationId: null,
    organizationUnitId: null,
    organizationUnitLocation: null,
    websiteId: null,
    location: null,
    language: null,
    organizationUnitName: null,
    organizationUnitPhone: null,
    schedule_monday: null,
    schedule_tuesday: null,
    schedule_wednesday: null,
    schedule_thursday: null,
    schedule_friday: null,
    schedule_saturday: null,
    schedule_sunday: null,
    salesDepartments: null,
    websiteLogo: null,
    websiteDomain: null,
    websiteFacebookPageUrl: null,
    websiteInstagramClientId: null,
    websiteInstagramUserId: null,
    websiteInstagramUrl: null,
    websiteTwitterUrl: null,
    websiteYoutubeUrl: null,
    dealerMake: null,
    isDigitalRetailing: null,
});

/* Helpers */
function getStringOrNull(value) {
    return isString(value) ? value : null;
}

class ConfigsModel extends ConfigsRecord {
    constructor(obj) {
        const args = pickBy(obj);
        const newArgs = {};

        if (args) {
            if (args.organizationUnitLocation) {
                const unitLocation = getStringOrNull(args.organizationUnitLocation);
                newArgs.organizationUnitLocation = unitLocation ? unitLocation.trim().toLowerCase() : null;
            }
            if (args.websiteInstagramClientId || args.websiteInstagramUserId) {
                const clientId = getStringOrNull(args.websiteInstagramClientId);
                const userId = getStringOrNull(args.websiteInstagramUserId);

                if (clientId) newArgs.websiteInstagramUrl = clientId;
                else if (userId) newArgs.websiteInstagramUrl = `https://www.instagram.com/${clientId}`;
            }
        }

        super({ ...args, ...newArgs });
    }

    getOrganizationId() {
        return this.organizationId || '';
    }

    getOrganizationUnitId() {
        return this.organizationUnitId || '';
    }

    getOrganizationUnitLocation() {
        return this.organizationUnitLocation || '';
    }

    getWebsiteId() {
        return this.websiteId || '';
    }

    getLocation() {
        return this.location || '';
    }

    getCountry() {
        const lowerCaseLocation = isString(this.organizationUnitLocation)
            ? this.organizationUnitLocation.toLowerCase()
            : undefined;
        const provinceObj = COUNTRIES.find((prov) => prov.code === lowerCaseLocation);
        return provinceObj ? provinceObj.country : null;
    }

    getOrganizationUnitName() {
        return this.organizationUnitName;
    }

    getOrganizationUnitPhone() {
        return this.organizationUnitPhone;
    }

    getScheduleMonday() {
        return this.scheduleMonday;
    }
    getScheduleTuesday() {
        return this.scheduleTuesday;
    }
    getScheduleWednesday() {
        return this.scheduleWednesday;
    }
    getScheduleThursday() {
        return this.scheduleThursday;
    }
    getScheduleFriday() {
        return this.scheduleFriday;
    }
    getScheduleSaturday() {
        return this.scheduleSaturday;
    }
    getScheduleSunday() {
        return this.scheduleSunday;
    }

    getSalesDepartments() {
        return this.salesDepartments;
    }

    getWebsiteLogo() {
        return this.websiteLogo;
    }

    getWebsiteDomain() {
        return this.websiteDomain;
    }

    getWebsiteFacebookUrl() {
        return this.websiteFacebookUrl;
    }

    getWebsiteInstagramUrl() {
        return this.websiteInstagramUrl;
    }

    getWebsiteTwitterUrl() {
        return this.websiteTwitterUrl;
    }

    getWebsiteYoutubeUrl() {
        return this.websiteYoutubeUrl;
    }

    getConfig() {
        return {
            orgId: this.organizationId,
            orgUnitId: this.organizationUnitId,
            location: this.organizationUnitLocation,
            websiteId: this.websiteId,
            orgUnitName: this.organizationUnitName,
            orgUnitPhone: this.organizationUnitPhone,
            schedule_monday: this.schedule_monday,
            schedule_tuesday: this.schedule_tuesday,
            schedule_wednesday: this.schedule_wednesday,
            schedule_thursday: this.schedule_thursday,
            schedule_friday: this.schedule_friday,
            schedule_saturday: this.schedule_saturday,
            schedule_sunday: this.schedule_sunday,
            salesDepartments: this.salesDepartments,
            websiteLogo: this.websiteLogo,
            websiteDomain: this.websiteDomain,
            websiteFacebookPageUrl: this.websiteFacebookPageUrl,
            websiteInstagramClientId: this.websiteInstagramClientId,
            websiteInstagramUserId: this.websiteInstagramUserId,
            websiteInstagramUrl: this.websiteInstagramUrl,
            websiteTwitterUrl: this.websiteTwitterUrl,
            websiteYoutubeUrl: this.websiteYoutubeUrl,
            dealerMake: this.dealerMake,
            isDigitalRetailing: this.isDigitalRetailing,
        };
    }
}

export default ConfigsModel;
